exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".create-gift[data-v-1e687f5e] path {\n  fill: #FFFFFF;\n}\n", ""]);
